<template>
  <Toast />
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '750px' }"
    :header="'CIERRE DE CAJA: #' + data_cajacierre.id"
    :modal="true"
    @hide="ocultarModal"
    class="p-fluid"
  >
    <div class="col-12">
      <!-- Etapa 4: avisos del cierre con ventas en la cola local (data-testid: pruebas automáticas, e2e/) -->
      <Message v-if="enviando" severity="info" :closable="false" data-testid="cierre-enviando">
        <i class="pi pi-spin pi-spinner mr-2"></i>Enviando ventas… ({{ progreso.k }} de {{ progreso.n }})
      </Message>
      <Message v-if="notaTotales" severity="warn" :closable="false" data-testid="cierre-totales-actualizados">
        Totales actualizados con las ventas recién enviadas: revise el recuento de efectivo.
      </Message>
      <Message v-if="ajustePendientes" severity="warn" :closable="false" data-testid="cierre-incluye-pendientes">
        Los totales incluyen {{ ajustePendientes.cantidad }} ventas sin enviar (Bs
        {{ convertirNumeroGermanicFormat(ajustePendientes.total) }}).
      </Message>
      <Divider align="left" class="mb-0 mt-0">
        <div class="inline-flex align-items-center">
          <i class="pi pi-unlock"></i>
          <b>DATOS DE APERTURA</b>
        </div>
      </Divider>
      <div class="p-fluid formgrid grid p-fondo">
        <div class="field col-12 md:col-6 mb-0">
          <label for=""
            ><strong>USUARIO : </strong>{{ data_cajacierre.nombre_user }}</label
          >
        </div>
        <div class="field col-12 md:col-6 mb-0">
          <label for=""
            ><strong>SUCURSAL : </strong
            >{{ data_cajacierre.nombre_sucursal }}</label
          >
        </div>
        <div class="field col-12 md:col-6 mb-0">
          <strong> MONTO INICIAL : </strong
          ><span style="font-size: 1.1em">
            {{ convertirNumeroGermanicFormat(data_cajacierre.saldo_inicial) }}
          </span>
        </div>
        <div class="field col-12 md:col-6 mb-0">
          <label for=""
            ><strong>FECHA APERTURA:</strong>
            {{ data_cajacierre.fecha_apertura }}</label
          >
        </div>
      </div>
      <Divider align="left" v-if="'Caja Ver Detalle' in auth.user.permissions">
        <div class="inline-flex align-items-center">
          <i class="pi pi-lock"></i>
          <b>DATOS DE CIERRE:</b>
          <span
            style="
              background-color: #d8fadb;
              border-radius: 2px;
              padding: 1px;
              color: black;
            "
            >(Expresado en Bs.)</span
          >
        </div>
      </Divider>

      <div
        class="p-fluid formgrid grid p-fondo2"
        v-if="'Caja Ver Detalle' in auth.user.permissions"
      >
        <div class="field col-12 md:col-4 mb-0">
          <strong> TOTAL VENTAS : </strong
          ><span style="font-size: 1.2em; font-weight: bold" data-testid="cierre-total-ventas">
            {{
              convertirNumeroGermanicFormat(
                data_cajacierre.calculo_total_ventas
              )
            }}
          </span>
          <!-- Etapa 4: nota cuando el cajero volvió al recuento con los totales ajustados -->
          <small v-if="ajustePendientes" class="block text-orange-600">
            incluye {{ ajustePendientes.cantidad }} ventas sin enviar (Bs
            {{ convertirNumeroGermanicFormat(ajustePendientes.total) }})
          </small>
        </div>
        <div class="field col-12 md:col-4 mb-0">
          <strong>TOTAL EFECTIVO: </strong
          ><span style="font-size: 1.2em; font-weight: bold" data-testid="cierre-total-efectivo">{{
            convertirNumeroGermanicFormat(
              data_cajacierre.calculo_total_saldo_caja
            )
          }}</span>
          <small v-if="ajustePendientes" class="block text-orange-600">
            incluye {{ ajustePendientes.cantidad }} ventas sin enviar (Bs
            {{ convertirNumeroGermanicFormat(ajustePendientes.efectivo) }})
          </small>
        </div>
        <!-- <div class="field col-12 md:col-4">
						<strong>TRANSFERENCIAS : </strong
						>{{
							convertirNumeroGermanicFormat(
								data_cajacierre.calculo_total_ventas_metodos_pago
							)
						}}
					</div> -->
        <div
          class="field col-12 md:col-4 mb-0"
          v-if="data_cajacierre.detalle_suma_cobros_x_metodos_pago.length > 0"
        >
          <div
            v-for="(
              item, index
            ) in data_cajacierre.detalle_suma_cobros_x_metodos_pago"
            :key="index"
          >
            <strong>{{ item.nombre }} : </strong
            ><span style="font-size: 1.2em; font-weight: bold">
              {{ convertirNumeroGermanicFormat(item.total) }}
            </span>
          </div>
        </div>
        <div class="field col-12 md:col-4 mb-0">
          <strong> TOTAL INGRESOS: </strong>
          <span style="font-size: 1.2em; color: green; font-weight: bold">
            {{
              convertirNumeroGermanicFormat(
                data_cajacierre.calculo_total_ingresos
              )
            }}
          </span>
        </div>
        <div class="field col-12 md:col-4 mb-0">
          <strong> TOTAL EGRESOS: </strong>
          <span style="font-size: 1.2em; color: red; font-weight: bold">
            {{
              convertirNumeroGermanicFormat(
                data_cajacierre.calculo_total_egresos
              )
            }}
          </span>
          <span v-if="data_cajacierre.calculo_total_egresos > 0">
            <br />
            <span class="mt-0">
              {{
                (data_cajacierre.calculo_total_pago_comision > 0
                  ? "Comisión: " +
                    convertirNumeroGermanicFormat(
                      data_cajacierre.calculo_total_pago_comision
                    )
                  : "") +
                (data_cajacierre.calculo_total_almuerzo > 0
                  ? (data_cajacierre.calculo_total_pago_comision > 0
                      ? ", "
                      : "") +
                    "Almuerzo: " +
                    convertirNumeroGermanicFormat(
                      data_cajacierre.calculo_total_almuerzo
                    )
                  : "")
              }}
            </span>
          </span>
        </div>
        <!-- <div class="field col-12 md:col-4">
            <strong>VENTAS AL CR&Eacute;DITO: </strong
            >{{
              convertirNumeroGermanicFormat(
                data_cajacierre.calculo_total_a_credito
              )
            }}
          </div> -->
        <div class="field col-12 md:col-4 mb-0">
          <strong> DIFERENCIA : </strong>
          <span
            v-if="diferencia > 0"
            style="font-size: 1.2em; color: green; font-weight: bold"
            data-testid="cierre-diferencia"
            >{{
              convertirNumeroGermanicFormat(diferencia ? diferencia : 0)
            }}</span
          >
          <span
            v-else
            style="font-size: 1.2em; color: red; font-weight: bold"
            data-testid="cierre-diferencia"
            >{{
              convertirNumeroGermanicFormat(diferencia ? diferencia : 0)
            }}</span
          >
        </div>
        <div class="field col-12 md:col-4 mb-0">
          <strong> SALDO CAJA EN SISTEMA: </strong>
          <span style="font-size: 1.2em; color: green; font-weight: bold">
            {{
              convertirNumeroGermanicFormat(
                data_cajacierre.calculo_total_saldo_caja
              )
            }}
          </span>
        </div>
        <div class="field col-12 md:col-4 mb-0">
          <strong> SALDO EN CAJA: </strong>
          <span style="font-size: 1.2em; font-weight: bold">
            {{ convertirNumeroGermanicFormat(saldo_caja ? saldo_caja : 0) }}
          </span>
        </div>
      </div>
      <Divider align="left">
        <div class="inline-flex align-items-center">
          <i class="pi pi-cog"></i>
          <b>OPERACIONES</b>
        </div>
      </Divider>
      <div class="p-fluid formgrid grid">
        <table class="field col-12 md:col-12">
          <thead>
            <tr v-if="mostrar_fecha_venta">
              <td>
                <strong>FECHA DE CIERRE:</strong>
                <!-- <Checkbox
                  v-model="fecha_cierre_diferente"
                  :binary="true"
                  v-tooltip.top="'Marque si la fecha es diferente a la actual'"
                /> -->
              </td>
              <td>
                <div class="p-inputgroup">
                  <Button
                    icon="pi pi-lock-open"
                    class="p-button-success"
                    v-tooltip.top="
                      'Marque si la fecha es diferente a la actual'
                    "
                    @click="fecha_cierre_diferente = !fecha_cierre_diferente"
                  />
                  <InputText
                    :disabled="!fecha_cierre_diferente"
                    v-model="data_cajacierre.fecha_cierre"
                    type="date"
                    :max="new Date().toISOString().split('T')[0]"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <strong
                  >RECUENTO EFECTIVO: <small class="p-invalid">*</small></strong
                >
              </td>
              <td data-testid="cierre-recuento">
                <InputNumber
                  id="recuento_efectivo"
                  inputClass="text-right"
                  :min="0"
                  :showButtons="true"
                  autofocus
                  v-model="data_cajacierre.recuento_efectivo"
                  :minFractionDigits="2"
                  locale="de-DE"
                  placeholder="Ingrese el Monto total en efectivo"
                  :class="{ 'p-invalid': errors.recuento_efectivo }"
                />
                <small class="p-invalid" v-if="errors.recuento_efectivo">{{
                  errors.recuento_efectivo[0]
                }}</small>
              </td>
            </tr>
            <tr
              v-if="
                data_cajacierre.tipo_negocio == 2 && mostrar_registro_medidor
              "
            >
              <td>
                <strong
                  >LECTURA FINAL: <small class="p-invalid">*</small></strong
                >
              </td>
              <td>
                <InputNumber
                  id="lectura_fin"
                  inputClass="text-right"
                  :min="0"
                  :showButtons="true"
                  v-model="data_cajacierre.lectura_fin"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  locale="de-DE"
                  placeholder="Ingrese el Lectura final del Medidor"
                  :class="{ 'p-invalid': errors.lectura_fin }"
                />
                <small class="p-invalid" v-if="errors.lectura_fin">{{
                  errors.lectura_fin[0]
                }}</small>
              </td>
            </tr>
            <tr>
              <td>
                <strong>OBSERVACIÓN: </strong>
              </td>
              <td>
                <Textarea
                  v-model="data_cajacierre.observacion"
                  rows="1"
                  autoResize
                />
                <small class="p-invalid" v-if="errors.observacion">{{
                  errors.observacion[0]
                }}</small>
              </td>
            </tr>
            <!--  <tr>
              <td></td>
              <td>
                <InputNumber
                  v-if="data_cajacierre.enviar_a_banco"
                  inputClass="text-right"
                  :min="0"
                  :showButtons="true"
                  v-model="data_cajacierre.monto_entregar"
                  :minFractionDigits="2"
                  locale="de-DE"
                  placeholder="Ingrese el Monto a enviar a Caja Principal"
                />
                <small class="p-invalid" v-if="errors.monto_entregar">{{
                  errors.monto_entregar[0]
                }}</small>
              </td>
            </tr> -->
          </thead>
        </table>
      </div>
      <div
        class="p-fluid formgrid grid"
        v-if="'Banco Listar' in auth.user.permissions"
      >
        <div class="field col-12 md:col-8">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <strong>ENTREGAR SOBRE?: </strong>
              <Checkbox
                v-model="enviar_a_banco"
                :binary="true"
                class="ml-1"
                @change="cargarBancos"
              />
            </span>
            <Dropdown
              v-if="enviar_a_banco"
              v-model="bancoSelected"
              :options="bancos"
              optionLabel="descripcion"
              optionValue="id"
              placeholder="Seleccione la Caja Principal"
              :class="{ 'p-invalid': errors.bancoSelected }"
            >
              <template #option="slotProps">
                <span class="font-weight-bold">
                  {{ slotProps.option.numero_cuenta ?? "" }} -
                  {{ slotProps.option.descripcion ?? "" }}
                </span>
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <InputNumber
            v-if="enviar_a_banco"
            inputClass="text-right"
            :min="0"
            :showButtons="true"
            v-model="monto_efectivo"
            :minFractionDigits="2"
            locale="de-DE"
            placeholder="Ingrese el Monto a enviar a Caja Principal"
          />
          <small class="p-invalid" v-if="errors.monto_efectivo">{{
            errors.monto_efectivo[0]
          }}</small>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="field">
        <label class="flex md:justify-content-start"
          ><strong>CAMPOS REQUERIDOS: </strong>
          <span class="p-invalid">*</span></label
        >
      </div>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        data-testid="cierre-cancelar"
        :disabled="enviando"
        @click="ocultarModal"
      />
      <Button
        label="GUARDAR"
        icon="pi pi-save"
        class="p-button-primary p-button-lg"
        data-testid="cierre-guardar"
        @click="guardarCajaCierre"
        :loading="enviado"
      />
    </template>
  </Dialog>

  <!-- Etapa 4 (D2): segundo diálogo, cierre provisional con los totales ajustados con las ventas sin enviar -->
  <Dialog
    v-model:visible="mostrarProvisional"
    :style="{ width: '600px' }"
    header="Cierre provisional"
    :modal="true"
    :closable="!enviado"
  >
    <div v-if="provisional" data-testid="cierre-provisional">
      <Message severity="warn" :closable="false">
        No se pudieron enviar <b>{{ provisional.pendientes }} ventas</b> (Bs
        {{ convertirNumeroGermanicFormat(provisional.resumen.total) }}). Los totales de abajo ya las incluyen.
        Revise el recuento de efectivo con estos totales antes de confirmar.
      </Message>
      <table class="w-full">
        <tr>
          <td><strong>TOTAL VENTAS:</strong></td>
          <td class="text-right">
            <b data-testid="cierre-provisional-total-ventas">{{
              convertirNumeroGermanicFormat(provisional.totales.calculo_total_ventas)
            }}</b>
            <small class="block text-orange-600">
              incluye {{ provisional.pendientes }} ventas sin enviar (Bs
              {{ convertirNumeroGermanicFormat(provisional.resumen.total) }})
            </small>
          </td>
        </tr>
        <tr>
          <td><strong>TOTAL EFECTIVO:</strong></td>
          <td class="text-right">
            <b data-testid="cierre-provisional-total-efectivo">{{
              convertirNumeroGermanicFormat(provisional.totales.calculo_total_saldo_caja)
            }}</b>
            <small v-if="provisional.resumen.efectivo > 0" class="block text-orange-600">
              incluye {{ provisional.pendientes }} ventas sin enviar (Bs
              {{ convertirNumeroGermanicFormat(provisional.resumen.efectivo) }})
            </small>
          </td>
        </tr>
        <tr
          v-for="item in provisional.totales.detalle_suma_cobros_x_metodos_pago"
          :key="item.metodo_pago_id"
        >
          <td><strong>{{ item.nombre }}:</strong></td>
          <td class="text-right">
            <b>{{ convertirNumeroGermanicFormat(item.total) }}</b>
            <small v-if="pendienteDelMetodo(item) > 0" class="block text-orange-600">
              incluye ventas sin enviar (Bs {{ convertirNumeroGermanicFormat(pendienteDelMetodo(item)) }})
            </small>
          </td>
        </tr>
        <tr>
          <td><strong>RECUENTO EFECTIVO:</strong></td>
          <td class="text-right">
            <b>{{ convertirNumeroGermanicFormat(saldo_caja ? saldo_caja : 0) }}</b>
          </td>
        </tr>
        <tr>
          <td><strong>DIFERENCIA:</strong></td>
          <td class="text-right">
            <b
              data-testid="cierre-provisional-diferencia"
              :style="diferenciaProvisional > 0 ? 'color: green' : 'color: red'"
              >{{ convertirNumeroGermanicFormat(diferenciaProvisional) }}</b
            >
          </td>
        </tr>
      </table>
    </div>
    <template #footer>
      <Button
        label="Volver al recuento"
        icon="pi pi-arrow-left"
        class="p-button-secondary"
        data-testid="cierre-provisional-volver"
        :disabled="enviado"
        @click="volverAlRecuento"
      />
      <Button
        label="Cerrar como provisional"
        icon="pi pi-lock"
        class="p-button-warning"
        data-testid="cierre-provisional-confirmar"
        :loading="enviado"
        @click="confirmarProvisional"
      />
    </template>
  </Dialog>
</template>
<script>
import CajaService from "@/service/CajaService";
// Etapa 4: antes import { useAuth } from "@/stores";
import { useAuth, useConexion } from "@/stores";
import BancoService from "@/service/BancoService";
// Etapa 4: cierre con ventas en la cola local (etapa_4_cierre_caja.md)
import { fechaIsoConOffset } from "@/helpers/fechaLocal";
import {
  contarPendientesDeCaja,
  enviarVentasDeCaja,
  prepararCierre,
  guardarCierre,
  enviarCierre,
  cierrePendienteDeCaja,
  limpiarCajaLocal,
} from "@/services-offline/cierresCaja";

// Etapa 4 (f): textos del cierre
const TEXTOS_CIERRE = {
  sinConexion:
    "Sin conexión no se puede cerrar la caja: el cierre necesita los totales del servidor. Las ventas siguen guardándose en el POS; cierre la caja cuando vuelva la conexión.",
  sinPermiso: "Este usuario no tiene permiso para cerrar cajas (Caja Cerrar).",
  fecha:
    "La hora del equipo no es correcta: corríjala (Configuración de Windows › Hora) y vuelva a intentar el cierre.",
  red: "Sin conexión con el servidor: el cierre quedó guardado en este equipo y se enviará solo al volver la conexión. La caja sigue abierta hasta entonces.",
  sesion:
    "Sesión vencida: el cierre quedó guardado en este equipo y se enviará al volver a iniciar sesión, con conexión.",
  duplicada: "La caja ya estaba cerrada con este cierre.",
};
const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export default {
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    cajacierre: {
      type: Object,
      default() {
        return {};
      },
    },
    mostrar_fecha_venta: {
      type: Boolean,
      default: false,
    },
    mostrar_registro_medidor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errors: {},
      enviado: false,
      mostrarModal: this.show,
      data_cajacierre: this.cajacierre,
      bancoSelected: null,
      bancos: [],
      enviar_a_banco: false,
      monto_efectivo: 0,
      fecha_cierre_diferente: false,
      // Etapa 4
      enviando: false, // esperando el envío de las ventas de la caja (D4)
      progreso: { k: 0, n: 0 },
      notaTotales: false, // r = 0: los totales se recargaron y cambiaron
      provisional: null, // resultado de prepararCierre() mientras se decide el cierre provisional
      mostrarProvisional: false,
      ajustePendientes: null, // el cajero volvió al recuento con los totales ajustados
      putEnCurso: false, // el PUT de cerrarConPut sigue en vuelo (no soltar «enviado» antes)
    };
  },
  cajacierreService: null,
  auth: null,
  bancoService: null,
  conexion: null,
  computed: {
    // Etapa 4: diferencia del segundo diálogo, contra el TOTAL EFECTIVO ajustado
    diferenciaProvisional() {
      if (!this.provisional) return 0;
      return r2(
        parseFloat(this.data_cajacierre.recuento_efectivo || 0) -
          this.provisional.totales.calculo_total_saldo_caja
      );
    },
    saldo_caja() {
      return parseFloat(this.data_cajacierre.recuento_efectivo);
    },
    diferencia() {
      return (
        parseFloat(this.data_cajacierre.recuento_efectivo) -
        parseFloat(this.data_cajacierre.calculo_total_saldo_caja)
      );
    },
  },
  created() {
    this.cajacierreService = new CajaService();
    this.auth = useAuth();
    this.bancoService = new BancoService();
    this.conexion = useConexion(); // Etapa 4
  },
  methods: {
    cargarBancos() {
      this.bancoService.getBancosAll().then((data) => {
        this.bancos = data.bancos;
      });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
    ocultarModal() {
      this.errors = {};
      this.mostrarModal = false;
      this.$emit("closeModal");
      this.enviado = false;
      this.fecha_cierre_diferente = false;
      this.reiniciarEstadoCierre(); // Etapa 4
    },
    // Etapa 4: estado del cierre con ventas en la cola
    reiniciarEstadoCierre() {
      this.enviando = false;
      this.progreso = { k: 0, n: 0 };
      this.notaTotales = false;
      this.provisional = null;
      this.mostrarProvisional = false;
      this.ajustePendientes = null;
    },
    validacionesForm() {
      if (
        this.data_cajacierre.tipo_negocio == 2 &&
        !this.data_cajacierre.lectura_fin &&
        this.mostrar_registro_medidor
      ) {
        this.errors.lectura_fin = [
          "DEBE INGRESAR LA LECTURA FINAL DEL MEDIDOR",
        ];
      }
      if (this.enviar_a_banco && !this.bancoSelected) {
        this.errors.bancoSelected = ["DEBE SELECCIONAR UNA CAJA PRINCIPAL"];
      }
      return Object.keys(this.errors).length === 0;
    },
    // Etapa 4: antes guardarCajaCierre() validaba y hacía el PUT directamente (ese código sigue, sin cambios de
    // fondo, en cerrarConPut). Ahora, con ventas de esta caja en la cola local: aviso → envío (hasta 60 s) →
    // si quedan, cierre provisional por POST /caja/sync. Sin ventas en la cola: el PUT de siempre.
    async guardarCajaCierre() {
      this.errors = {};
      if (!this.validacionesForm()) {
        return;
      }
      // O1 (D1): sin conexión no se cierra
      if (this.conexion.modoOffline) {
        this.toastCierre("error", TEXTOS_CIERRE.sinConexion);
        return;
      }
      const cajaId = this.data_cajacierre.id;
      this.notaTotales = false;
      this.enviado = true;
      try {
        // El cajero volvió al recuento: directo al diálogo provisional (la suma servidor + pendientes no cambia
        // aunque entretanto se envíe alguna venta, así que lo preparado sigue valiendo)
        if (this.provisional) {
          this.mostrarProvisional = true;
          return;
        }
        // Ya hay un cierre de esta caja guardado en el equipo: se reintenta ese (mismo uuid_cierre), no otro
        const previo = await cierrePendienteDeCaja(cajaId);
        if (previo) {
          const resultado = await enviarCierre(previo.uuid_cierre);
          const quedan = (await contarPendientesDeCaja(cajaId)).pendientes;
          this.aplicarResultadoCierre(resultado, quedan);
          return;
        }
        const pend = await contarPendientesDeCaja(cajaId);
        if (!pend.pendientes) {
          // a) cola vacía: igual que hoy
          this.cerrarConPut();
          return;
        }
        // b) aviso (no bloquea): Cancelar no hace nada
        if (!(await this.confirmarAviso(pend))) return;
        this.enviando = true;
        this.progreso = { k: 0, n: pend.pendientes };
        await enviarVentasDeCaja(cajaId, (k, n) => {
          this.progreso = { k, n };
        });
        this.enviando = false;
        const prep = await prepararCierre(cajaId);
        if (prep.error) {
          this.toastCierre("error", prep.error === "sesion" ? TEXTOS_CIERRE.sesion : TEXTOS_CIERRE.sinConexion);
          return;
        }
        if (!prep.pendientes) {
          // Se enviaron todas: los totales del formulario no las tenían. Si cambiaron, el cajero revisa y confirma.
          if (this.aplicarTotales(prep.totalesServidor)) {
            this.notaTotales = true;
            return;
          }
          this.cerrarConPut();
          return;
        }
        this.provisional = prep;
        this.mostrarProvisional = true;
      } catch (e) {
        console.error("Cierre de caja:", e);
        this.toastCierre("error", "No se pudo completar el cierre: " + (e && e.message ? e.message : e));
      } finally {
        this.enviando = false;
        // cerrarConPut maneja su propio «enviado» (la petición sigue en curso)
        if (!this.putEnCurso) this.enviado = false;
      }
    },
    toastCierre(severity, detail) {
      const summary = { success: "Exito!", warn: "Aviso", error: "Error" }[severity] || "Aviso";
      this.$toast.add({ severity, summary, detail, life: severity === "success" ? 4000 : 8000 });
    },
    // Aviso de la Etapa 4 (f) con ConfirmDialog (el de CajaList). Resuelve true con «Enviar y cerrar».
    confirmarAviso(pend) {
      let mensaje =
        `Hay ${pend.pendientes} ventas de esta caja sin enviar al servidor. Se intentará enviarlas antes de cerrar. ` +
        "Si alguna no se puede enviar, la caja se cerrará como provisional y esas ventas se registrarán solas " +
        "cuando haya conexión. ¿Cerrar la caja igualmente?";
      if (pend.rechazadas) {
        mensaje += ` Además hay ${pend.rechazadas} ventas rechazadas de esta caja: revíselas en «Ventas» del POS. No se incluyen en el cierre.`;
      }
      if (pend.deOtroUsuario) {
        mensaje += ` ${pend.deOtroUsuario} de ellas son de ${pend.cajerosOtros.join(", ")}: solo se envían cuando ese usuario inicia sesión en este equipo.`;
      }
      return new Promise((resolve) => {
        let respondido = false;
        const responder = (valor) => {
          if (!respondido) {
            respondido = true;
            resolve(valor);
          }
        };
        this.$confirm.require({
          header: "Ventas sin enviar",
          message: mensaje,
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Enviar y cerrar",
          rejectLabel: "Cancelar",
          // El ConfirmDialog de PrimeVue no acepta atributos en los botones: las pruebas los ubican por clase
          acceptClass: "cierre-aviso-confirmar",
          rejectClass: "cierre-aviso-cancelar",
          accept: () => responder(true),
          reject: () => responder(false),
          onHide: () => responder(false),
        });
      });
    },
    // r = 0 tras el envío: totales del servidor en el formulario. Devuelve true si cambiaron.
    aplicarTotales(totales) {
      const d = this.data_cajacierre;
      const cambio =
        r2(d.calculo_total_ventas) !== r2(totales.calculo_total_ventas) ||
        r2(d.calculo_total_saldo_caja) !== r2(totales.calculo_total_saldo_caja) ||
        JSON.stringify(d.detalle_suma_cobros_x_metodos_pago || []) !==
          JSON.stringify(totales.detalle_suma_cobros_x_metodos_pago || []);
      Object.assign(d, JSON.parse(JSON.stringify(totales)));
      return cambio;
    },
    // Lo pendiente de un método en el segundo diálogo (ajustado − servidor)
    pendienteDelMetodo(item) {
      if (!this.provisional) return 0;
      const servidor = (this.provisional.totalesServidor.detalle_suma_cobros_x_metodos_pago || []).find(
        (f) => Number(f.metodo_pago_id) === Number(item.metodo_pago_id)
      );
      return r2(item.total - (servidor ? Number(servidor.total) || 0 : 0));
    },
    volverAlRecuento() {
      this.mostrarProvisional = false;
      // El formulario pasa a mostrar los totales ajustados (con la nota «incluye r ventas…»)
      Object.assign(this.data_cajacierre, JSON.parse(JSON.stringify(this.provisional.totales)));
      this.ajustePendientes = { cantidad: this.provisional.pendientes, ...this.provisional.resumen };
    },
    // Los mismos datos que manda hoy el PUT (ver cerrarConPut)
    datosDelFormulario() {
      return {
        ...this.data_cajacierre,
        estado: this.data_cajacierre.estado.value,
        total_ventas: this.data_cajacierre.calculo_total_ventas,
        diferencia: this.diferencia,
        saldo_caja: this.saldo_caja,
        recuento_metodos_pago:
          this.data_cajacierre.detalle_suma_cobros_x_metodos_pago,
        lectura_fin: this.data_cajacierre.lectura_fin,
        enviar_a_banco: this.enviar_a_banco,
        banco_id: this.bancoSelected,
        monto_efectivo: this.monto_efectivo,
        mostrar_fecha_venta: this.mostrar_fecha_venta,
        fecha_cierre_diferente: this.fecha_cierre_diferente,
        mostrar_registro_medidor: this.mostrar_registro_medidor,
      };
    },
    // b) «Cerrar como provisional»: el cierre se guarda en cierres_cola ANTES de enviarlo (d)
    async confirmarProvisional() {
      const p = this.provisional;
      const t = p.totales;
      const recuento = r2(this.data_cajacierre.recuento_efectivo);
      // Hora del equipo al confirmar, con la corrección de reloj de la 3D si el equipo va adelantado
      const { fecha } = this.conexion.fechaVentaCorregida();
      const payload = JSON.parse(
        JSON.stringify({
          ...this.datosDelFormulario(),
          ...t,
          total_ventas: t.calculo_total_ventas,
          recuento_metodos_pago: t.detalle_suma_cobros_x_metodos_pago,
          diferencia: r2(recuento - t.calculo_total_saldo_caja),
          saldo_caja: recuento,
          recuento_efectivo: recuento,
          observacion: this.data_cajacierre.observacion || null,
          cantidad_ventas_sesion: p.cantidad_ventas_sesion,
          fecha_cierre: fechaIsoConOffset(fecha),
        })
      );
      this.enviado = true;
      try {
        const fila = await guardarCierre(this.data_cajacierre.id, payload);
        const resultado = await enviarCierre(fila.uuid_cierre);
        this.aplicarResultadoCierre(resultado, p.pendientes);
      } catch (e) {
        console.error("Cierre provisional:", e);
        this.toastCierre("error", "No se pudo guardar el cierre: " + (e && e.message ? e.message : e));
      } finally {
        this.enviado = false;
      }
    },
    // Respuesta de POST /caja/sync (cierresCaja.enviarCierre) → aviso al cajero (f)
    aplicarResultadoCierre(r, pendientes) {
      const id = this.data_cajacierre.id;
      const terminar = () => {
        this.$emit("actualizarListado");
        this.ocultarModal();
      };
      switch (r.tipo) {
        case "ok":
          if (r.es_provisional) {
            this.toastCierre(
              "success",
              `Caja cerrada como provisional: faltan ${pendientes} ventas por enviar. Se enviarán solas cuando haya conexión.`
            );
          } else {
            this.toastCierre("success", r.mensaje || "Caja Cerrada con éxito!");
          }
          terminar();
          break;
        case "duplicada":
          this.toastCierre("success", TEXTOS_CIERRE.duplicada);
          terminar();
          break;
        case "ya_cerrada":
          this.toastCierre("warn", `La caja #${id} ya fue cerrada${r.fecha ? ` el ${r.fecha}` : ""}. No se volvió a cerrar.`);
          terminar();
          break;
        case "red":
          this.toastCierre("warn", TEXTOS_CIERRE.red);
          terminar();
          break;
        case "sesion":
          this.toastCierre("warn", TEXTOS_CIERRE.sesion);
          terminar();
          break;
        case "fecha":
          this.mostrarProvisional = false;
          this.provisional = null;
          this.toastCierre("error", TEXTOS_CIERRE.fecha);
          break;
        case "sin_permiso":
          this.mostrarProvisional = false;
          this.toastCierre("error", TEXTOS_CIERRE.sinPermiso);
          break;
        default:
          this.mostrarProvisional = false;
          this.provisional = null;
          this.toastCierre("error", r.mensaje || "No se pudo cerrar la caja.");
      }
    },
    // a) El cierre de siempre (PUT /caja/{id}); antes era el cuerpo de guardarCajaCierre()
    cerrarConPut() {
      this.enviado = true;
      this.putEnCurso = true;
      let tmp = {
        ...this.data_cajacierre,
        estado: this.data_cajacierre.estado.value,
        total_ventas: this.data_cajacierre.calculo_total_ventas,
        diferencia: this.diferencia,
        saldo_caja: this.saldo_caja,
        recuento_metodos_pago:
          this.data_cajacierre.detalle_suma_cobros_x_metodos_pago,
        lectura_fin: this.data_cajacierre.lectura_fin,
        enviar_a_banco: this.enviar_a_banco,
        banco_id: this.bancoSelected,
        monto_efectivo: this.monto_efectivo,
        mostrar_fecha_venta: this.mostrar_fecha_venta,
        fecha_cierre_diferente: this.fecha_cierre_diferente,
        mostrar_registro_medidor: this.mostrar_registro_medidor,
      };

      // Etapa 4: antes this.cajacierreService.updatedCaja(tmp).then((data) => {
      this.cajacierreService
        .updatedCaja(tmp)
        .then(async (data) => {
          this.putEnCurso = false;
          if (Object.prototype.hasOwnProperty.call(data, "errors")) {
            this.errors = data.errors;
            this.enviado = false;
          } else if (data.autorizado === false) {
            // D14: antes caía en la rama de éxito (toast verde vacío) y la caja seguía abierta
            this.toastCierre("error", TEXTOS_CIERRE.sinPermiso);
            this.enviado = false;
          } else {
            if (data.status == 400) {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: data.mensaje,
                life: 3000,
              });
              this.enviado = false;
            } else {
              // H3 (D7): el POS sin red no debe seguir vendiendo en la caja cerrada
              await limpiarCajaLocal(tmp.id).catch((e) =>
                console.warn("No se pudo limpiar la caja del catálogo local:", e)
              );
              this.$toast.add({
                severity: "success",
                summary: "Exito!",
                detail: data.mensaje,
                life: 3000,
              });
              this.$emit("actualizarListado");
              this.ocultarModal();
              this.enviado = false;
            }
          }
        })
        // Etapa 4: sin catch, un error de red dejaba GUARDAR girando para siempre
        .catch((e) => {
          this.putEnCurso = false;
          this.enviado = false;
          this.toastCierre("error", typeof e === "string" && e ? e : TEXTOS_CIERRE.sinConexion);
        });
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },
    cajacierre(val) {
      val.diferencia = 0;
      val.recuento_efectivo = null;
      val.monto_entregar = 0;
      val.fecha_cierre = new Date();
      val.lectura_fin = null;
      this.data_cajacierre = val;
      this.reiniciarEstadoCierre(); // Etapa 4: otra caja, otro cierre
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
  font-weight: bold;
}
.p-fondo {
  background-color: #d8fadb;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #000000;
}
.p-fondo2 {
  background-color: #f8d7da;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #000000;
}
.p-inputgroup-addon {
  background-color: #ffffff;
  font-weight: bold;
  color: #000000;
  border: none;
}
</style>
